interface ShowProps {
	if: any;
	children: any;
}

export const Show = (props: ShowProps) => {
	return props.if ? props.children : null;
};
